import { render, staticRenderFns } from "./validasi.vue?vue&type=template&id=7604860d&"
import script from "./validasi.vue?vue&type=script&lang=js&"
export * from "./validasi.vue?vue&type=script&lang=js&"
import style0 from "./validasi.vue?vue&type=style&index=0&id=7604860d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports